import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {yup} from "./index";


export const useIncidentAttachmentSchema = () => {
    const {t} = useTranslation('validation');

    return useMemo(
        () => (
            yup.object().shape({
                    attachmentType: yup.string().required(t('validation:required')),
                    attachmentSource: yup.string().required(t('validation:required')),
                    visibility: yup.string().required(t('validation:required')),
                    description: yup.string().required(t('validation:required')),
                    webLink: yup.string().url(t('validation:url')).when(
                        ['file', 'fileUpload'],
                        {
                            is: (file, fileUpload) => !file && !fileUpload,
                            then: (schema) => schema.required(t('validation:required')),
                            otherwise: (schema) => schema.notRequired(),
                        }),
                    fileUpload: yup.mixed().when(
                        ['file', 'webLink'],
                        {
                            is: (file, webLink) => !file && !webLink,
                            then: (schema) => schema.required(t('validation:required')).test('fileSize', t('validation:fileSize5MB'), (value) => {
                                return value && value.size <= 1024 * 1024 * 5 // 5 MB
                            }),
                            otherwise: (schema) => schema.notRequired(),
                        })
                },
                [['fileUpload', 'webLink'],]))
        ,
        [t]
    )
}